import LinkComponentsTable from "./LinkComponentsTable";
export default LinkComponentsTable;
